(function(e) {
  
  function getWarrantyVariantId() {
    if (typeof window === "undefined") return null;
    return window.cart_warranty_variant_id || null;
  }

  // Helper to format money as "symbol + amount" (no trailing currency code)
  function formatMoneySymbolOnly(cents) {
    if (typeof Shopify === "undefined" || typeof Shopify.formatMoney !== "function") {
      return "";
    }
    var formatted = Shopify.formatMoney(cents, window.money_format);
    // Remove any trailing 3-letter currency code like " USD"
      formatted = formatted.replace(/\s?[A-Z]{3}\b/, "");
      // Drop .00 / ,00 so whole-dollar amounts read as $199
      formatted = formatted.replace(/([.,]00)(?!\d)/, "");
      return formatted;
    }

    // Cart AJAX items do not include compare_at_price; cache it from /products/{handle}.js
    var variantCompareAtCache = {};

    function fetchVariantCompareAtMap(items, done) {
      var handles = [];
      var seen = {};
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var handle = item.handle;
        // Skip products whose variant compare_at is already cached
        if (typeof variantCompareAtCache[item.variant_id] !== "undefined") continue;
        if (handle && !seen[handle]) {
          seen[handle] = true;
          handles.push(handle);
        }
      }

      if (!handles.length) {
        done(variantCompareAtCache);
        return;
      }

      var remaining = handles.length;
      var finish = function() {
        remaining -= 1;
        if (remaining <= 0) done(variantCompareAtCache);
      };

      for (var h = 0; h < handles.length; h++) {
        (function(productHandle) {
          e.getJSON("/products/" + productHandle + ".js")
            .done(function(product) {
              if (product && product.variants) {
                for (var v = 0; v < product.variants.length; v++) {
                  var variant = product.variants[v];
                  variantCompareAtCache[variant.id] = variant.compare_at_price || 0;
                }
              }
            })
            .always(finish);
        })(handles[h]);
      }
  }

  // Helper to sync desktop + mobile header cart counts
  function updateHeaderCartCounts(count) {
    var itemLabel = (window.items || "items");
    var itemText = count + " " + itemLabel;

    // Update ALL cartCount elements (desktop + mobile)
    e("#cartCount").each(function() {
      var $el = e(this);
      var $countSpan = $el.find(".count");
      if ($countSpan.length) {
        // Mobile markup: update just the numeric badge, preserve SVG and layout
        $countSpan.text(count + " ");
      } else {
        // Desktop mini-cart text
        $el.text(itemText);
      }
    });

    document.querySelectorAll(".count").forEach((item) => {
      item.textContent = count + " ";
    });
    console.log("count:: ", count);
  }
  
   if (e(".collection_sidebar")) {
        //work only in collection page
        History.Adapter.bind(window, 'statechange', function() {
            var State = History.getState();
            if (!t.isSidebarAjaxClick) {
                t.sidebarParams();
                var newurl = t.sidebarCreateUrl();
                t.sidebarGetContent(newurl);
                t.reActivateSidebar();
            }
            t.isSidebarAjaxClick = false;
        });
    }

  
  
      
    
  
  
    e(document).ready(function() {
        t.init()
    });
  
  
     e(document).on("click touchstart", function(n) {
            var r = e(".quick-view");
            var i = e("#slidedown-cart");
            var s = e("#ToggleDown");
            var o = e("#email-modal .modal-window");
        
            if (!r.is(n.target) && r.has(n.target).length === 0 && !i.is(n.target) && i.has(n.target).length === 0 && !s.is(n.target) && s.has(n.target).length === 0 && !o.is(n.target) && o.has(n.target).length === 0 ) {
                t.closeQuickViewPopup();
                t.closeDropdownCart();
                t.closeEmailModalWindow();
               
            }
        })
    
    e(document).keyup(function(n) {
        if (n.keyCode == 27) {
            t.closeQuickViewPopup();
            t.closeDropdownCart();
            clearTimeout(t.KidsTimeout);
            if (e(".modal").is(":visible")) {
                e(".modal").fadeOut(500)
            }
        }
    });
    var t = {
        KidsTimeout: null,
        isSidebarAjaxClick: false,
        init: function() {    
            this.initQuickView();
            this.initAddToCart();
            this.initModal();
            this.initProductAddToCart();
            this.initDropDownCart();
            this.initCartDrawer();
            this.initWishlist();
            this.initRemoveWishlist();
            this.initProductWishlist();     
            this.initProductMoreview();
            this.initelevateZoom();
            this.initShortcode();
            this.initParallax();
            this.initScrollTop();
            
            this.initHeaderSticky();
            
            this.initSidebar();
            this.initColorSwatchGrid();  
            this.initInfiniteScrolling();
         
           
        },
       initColorSwatchGrid: function() { 
          jQuery('.item-swatch li label').click(function(){                                   
            var newImage = jQuery(this).parent().find('.hidden img').attr('src');
           jQuery(this).parents('.item-row').find('.featured-image').attr({ src: newImage }); 
            return false;
          });
        },
      
      
       initHeaderSticky: function(){
       var w = window.innerWidth;
       if (w > 767) {          
         e(".header-sticky").sticky({topSpacing:0});
         var headerH = $('.header-sticky').height();
            e(document).bind('ready scroll', function() {
              var docScroll = $(document).scrollTop();
                if(docScroll >= headerH) {
                    if (!e('#header-landing').hasClass('header-animate')) {
                        e('#header-landing').addClass('header-animate').css({ top: '-155px' }).stop().animate({ top: 0 }, 500);
                    }
                } else {
                    e('#header-landing').removeClass('header-animate').removeAttr('style');
                }
            });
        }
     if (w < 767) { e('.desktop-megamenu').remove();}
       },
      
      initScrollTop: function(){
      e().UItoTop({ easingType: 'easeOutQuart' });
      },
  
       initParallax: function() {        
        e('.parallax').each(function(){
          e(this).bind('inview', function (event, visible) {
            if(visible == true) {
              e(this).parallax("50%", 0.3);
            } else {
              e(this).css('background-position','');
            }
          });
        });
       },


      initShortcode: function() {
       e('.dt-sc-toggle').toggle(function(){ e(this).addClass('active'); },function(){ e(this).removeClass('active'); });
	   e('.dt-sc-toggle').click(function(){ e(this).next('.dt-sc-toggle-content').slideToggle(); });
	   e('.dt-sc-toggle-frame-set').each(function(){
		var $this = e(this),
		$toggle = $this.find('.dt-sc-toggle-accordion');
		
		$toggle.click(function(){
			if( e(this).next().is(':hidden') ) {
				$this.find('.dt-sc-toggle-accordion').removeClass('active').next().slideUp();
				e(this).toggleClass('active').next().slideDown();
			}
			return false;
		});
		
		//Activate First Item always
		$this.find('.dt-sc-toggle-accordion:first').addClass("active");
		$this.find('.dt-sc-toggle-accordion:first').next().slideDown();
	});/* Toggle Shortcode end*/
    
    //TABS...
	if(e('ul.tabs').length > 0) {
	  e('ul.tabs').tabs('> .dt-sc-tabs_content');
	}
	
	if(e('ul.dt-sc-tabs-frame').length > 0){
	e('ul.dt-sc-tabs-frame').tabs('> .dt-sc-tabs-frame-content');
	}
	
	if(e('ul.tabs').length > 0) {
		e('ul.tabs').tabs('> .dt-sc-tabs_content');
	}
	
	if(e('ul.dt-sc-tabs').length > 0) {
		e('ul.dt-sc-tabs').tabs('> .dt-sc-tabs-content');
	}
  
	if(e('.dt-sc-tabs-vertical-frame').length > 0){
	
		e('.dt-sc-tabs-vertical-frame').tabs('> .dt-sc-tabs-vertical-frame-content');
		
		e('.dt-sc-tabs-vertical-frame').each(function(){
			e(this).find("li:first").addClass('first').addClass('current');
			e(this).find("li:last").addClass('last');
		});
		
		e('.dt-sc-tabs-vertical-frame li').click(function(){
			e(this).parent().children().removeClass('current');
			e(this).addClass('current');
		});
		
	}
  
      },
      
     
      
        initWishlist: function() {
            e(".item-row button.wishlist").click(function(n) {
                n.preventDefault();
                var r = e(this).parent();
                var i = r.parents(".item-row");
                e.ajax({
                    type: "POST",
                    url: "/contact",
                    data: r.serialize(),
                    beforeSend: function() {
                        t.showLoading()
                    },
                    success: function(n) {
                        t.hideLoading();                     
                       var o = i.find(".featured-image").attr("src");
                       var wp = i.find(".grid-link__title").text();
                       var wamt = i.find(".grid-link__meta .product_price .grid-link__org_price span.money").text();                         
                      
                       e(".ajax-success-modal").find(".added-to-wishlist").show();
                       e(".ajax-success-modal").find(".added-to-cart").hide();
                      
                       e(".ajax-success-modal").find(".ajax-product-image").attr("src", o);
                       e(".ajax-success-modal").find(".ajax-product-title").text(wp);
                       e(".ajax-success-modal").find(".ajax_price").text(wamt);
                      
                      
                       t.showModal(".ajax-success-modal")
                    },
                    error: function(n, r) {
                        t.hideLoading();
                        e(".loading-modal").hide();
                        e(".ajax-error-message").text(e.parseJSON(n.responseText).description);
                        t.showModal(".ajax-error-modal")
                    }
                })
            })
        },
       initRemoveWishlist: function() {
            e(".btn-remove-wishlist").click(function() {
                var i = e(this).parents("tr"),
                    a = i.find(".tag-id").val(),
                    o = jQuery("#remove-wishlist-form");
                o.find("input[name='contact[tags]']").val("x" + a), e.ajax({
                    type: "POST",
                    url: "/contact",
                    data: o.serialize(),
                    beforeSend: function() {
                        t.showLoading()
                    },
                    success: function() {
                        t.hideLoading(), i.fadeOut(1e3)
                    },
                    error: function(i) {
                        t.hideLoading(), e(".loading-modal").hide(), e(".ajax-error-message").text(e.parseJSON(i.responseText).description), t.showModal(".ajax-error-modal")
                    }
                })
            })
        },
      
      
      
       initelevateZoom: function() {
            e("#product-featured-image").length > 0 && (e(".visible-phone").is(":visible") ? (e("#product-featured-image").elevateZoom({
                gallery: "ProductThumbs",
                cursor: "pointer",
                galleryActiveClass: "active",
                imageCrossfade: !1,
                scrollZoom: !1,
                onImageSwapComplete: function() {
                    e(".zoomWrapper div").hide()
                },
                loadingIcon: window.loading_url
            }), e("#product-featured-image").bind("click", function() {
                return !1
            })) : (e("#product-featured-image").elevateZoom({
                gallery: "ProductThumbs",
                cursor: "pointer",
                galleryActiveClass: "active",
                imageCrossfade: !0,
                scrollZoom: !0,
                onImageSwapComplete: function() {
                    e(".zoomWrapper div").hide()
                },
                loadingIcon: window.loading_url
            }), e("#product-featured-image").bind("click", function() {
                var i = e("#product-featured-image").data("elevateZoom");
                return e.fancybox(i.getGalleryList()), !1
            })))
        },
      
      
      
     
     initProductMoreview: function() {
      e(".more-view-wrapper-owlslider ul").owlCarousel({
                navigation: true,
                items: 4,
                itemsDesktop: [1199, 3],
                itemsDesktopSmall: [979, 3],
                itemsTablet: [768, 3],
                itemsTabletSmall: [540, 3],
                itemsMobile: [360, 3]
            }).css("visibility", "visible")
        
        },
        initProductWishlist: function() {
            e(".product-single button.wishlist").click(function(n) {
                n.preventDefault();
                var r = e(this).parent();
                var i = r.parents(".grid-item");
                e.ajax({
                    type: "POST",
                    url: "/contact",
                    data: r.serialize(),
                    beforeSend: function() {
                        t.showLoading()
                    },
                    success: function(n) {
                        t.hideLoading();                  
                       var o = e("#product-featured-image").attr("src");
                       var wp = e(".product-single__title").text();
                       var wamt = e(".product-single__price .grid-link__org_price span.money").text();   
                       
                      e(".ajax-success-modal").find(".added-to-wishlist").show();
                      e(".ajax-success-modal").find(".added-to-cart").hide();
                      e(".ajax-success-modal").find(".ajax-product-image").attr("src", o);    
                      e(".ajax-success-modal").find(".ajax-product-title").text(wp);
                      e(".ajax-success-modal").find(".ajax_price").text(wamt);
                      
                      
                      t.showModal(".ajax-success-modal")
                    },
                    error: function(n, r) {
                        t.hideLoading();
                        e(".loading-modal").hide();
                        e(".ajax-error-message").text(e.parseJSON(n.responseText).description);
                        t.showModal(".ajax-error-modal")
                    }
                })
            })
        },
      
        showModal: function(n) {
            e(n).fadeIn(500);
            t.KidsTimeout = setTimeout(function() {
                e(n).fadeOut(500)
            }, 5e3)
        },
        checkItemsInDropdownCart: function() {
            if (e("#slidedown-cart .mini-products-list").children().length > 0) {
                e("#slidedown-cart .no-items").hide();
                e("#slidedown-cart .has-items").show()
            } else {
                e("#slidedown-cart .has-items").hide();
                e("#slidedown-cart .no-items").show()
            }
        },
        initModal: function() {
            e(".continue-shopping").click(function() {
                clearTimeout(t.KidsTimeout);
                e(".ajax-success-modal").fadeOut(500)
            });
            e(".close-modal, .overlay").click(function() {
                clearTimeout(t.KidsTimeout);
                e(".ajax-success-modal").fadeOut(500)
            })
        },
        initDropDownCart: function() {
            if (window.use_cart_drawer) {
                return;
            }
            if (window.dropdowncart_type == "click") {
                e("#ToggleDown").click(function() {
                    if (e("#slidedown-cart").is(":visible")) {
                        e("#slidedown-cart").slideUp("fast")
                    } else {
                        e("#slidedown-cart").slideDown("fast")
                    }
                })
            } else {
                if (!("ontouchstart" in document)) {
                    e("#ToggleDown").hover(function() {
                        if (!e("#slidedown-cart").is(":visible")) {
                            e("#slidedown-cart").slideDown("fast")
                        }
                    });
                    e(".wrapper-top-cart").mouseleave(function() {
                        e("#slidedown-cart").slideUp("fast")
                    })
                } else {
                    e("#ToggleDown").click(function() {
                        if (e("#slidedown-cart").is(":visible")) {
                            e("#slidedown-cart").slideUp("fast")
                        } else {
                            e("#slidedown-cart").slideDown("fast")
                        }
                    })
                }
            }
            t.checkItemsInDropdownCart();
            e("#slidedown-cart .no-items a").click(function() {
                e("#slidedown-cart").slideUp("fast")
            });
            e("#slidedown-cart .btn-remove").click(function(n) {
                n.preventDefault();
                var r = e(this).parents(".item").attr("id");
                r = r.match(/\d+/g);
                Shopify.removeItem(r, function(e) {
                    t.doUpdateDropdownCart(e)
                })
            })
        },
        closeDropdownCart: function() {
            if (e("#slidedown-cart").is(":visible")) {
                e("#slidedown-cart").slideUp("fast")
            }
        },
        initCartDrawer: function() {
            var n = this;
            var overlay = e("#cart-drawer-overlay");
            var drawer = e("#cart-drawer");

            if (!overlay.length || !drawer.length) {
                return;
            }

            e(document).on("click", ".cart-drawer__close", function(t) {
                t.preventDefault();
                n.closeCartDrawer();
            });

            overlay.on("click", function(t) {
                if (t.target === this) {
                    n.closeCartDrawer();
                }
            });

            e(document).on("click", ".cart-drawer-item__remove", function(t) {
                t.preventDefault();
                var r = e(this).closest(".cart-drawer-item").attr("id");
                if (!r) return;
                r = r.match(/\d+/g);
                if (!r || !r.length) return;
                Shopify.removeItem(r, function(cart) {
                    n.refreshCartDrawer();
                    if (typeof n.doUpdateDropdownCart === "function") {
                        n.doUpdateDropdownCart(cart);
                    }
                });
            });

            // Open drawer from header cart count / icon
            e(document).on("click", "#cartCount, #ToggleDown", function(t) {
                if (!drawer.length) return;
                t.preventDefault();
                t.stopPropagation();
                // Ensure latest cart content before opening
                n.refreshCartDrawer();
                n.openCartDrawer();
            });

            // Quantity plus/minus handlers
            e(document).on("click", ".cart-drawer-qty-minus, .cart-drawer-qty-plus", function(t) {
                t.preventDefault();
                var isPlus = e(this).hasClass("cart-drawer-qty-plus");
                var container = e(this).closest(".cart-drawer-qty-box");
                var input = container.find(".cart-drawer-qty-input");
                var lineAttr = container.attr("data-line") || input.attr("data-line");
                var current = parseInt(input.val(), 10) || 1;
                var next = isPlus ? current + 1 : current - 1;
                if (next < 1) next = 1;
                input.val(next);
                n.updateCartLineQuantity(lineAttr, next);
            });

            e(document).on("change", ".cart-drawer-qty-input", function() {
                var input = e(this);
                var lineAttr = input.attr("data-line");
                var value = parseInt(input.val(), 10);
                if (isNaN(value) || value < 1) {
                    value = 1;
                    input.val(value);
                }
                n.updateCartLineQuantity(lineAttr, value);
            });

            e(document).on("click", ".cart-drawer__warranty-btn", function(t) {
                t.preventDefault();
                var btn = e(this);
                var variantId = btn.data("variant-id") || WARRANTY_VARIANT_ID;
                if (!variantId) return;
                console.log("Warranty add-to-cart clicked", { variantId: variantId });
                btn.prop("disabled", true);
                e.ajax({
                    type: "post",
                    url: "/cart/add.js",
                    data: {
                        quantity: 1,
                        id: variantId
                    },
                    dataType: "json",
                    success: function() {
                        n.refreshCartDrawer();
                        n.openCartDrawer();
                    },
                    complete: function() {
                        btn.prop("disabled", false);
                    }
                });
            });
        },
        openCartDrawer: function() {
            e("body").addClass("cart-drawer-open");
            e("#cart-drawer-overlay").addClass("is-visible");
        },
        closeCartDrawer: function() {
            e("body").removeClass("cart-drawer-open");
            e("#cart-drawer-overlay").removeClass("is-visible");
        },
        refreshCartDrawer: function() {
            var n = this;
            var drawer = e("#cart-drawer");
            if (!drawer.length) {
                return;
            }
            Shopify.getCart(function(cart) {
                var itemsContainer = e("#cart-drawer-items");
                var emptyState = e("#cart-drawer-empty");
                var footer = e(".cart-drawer__footer");
                if (!itemsContainer.length) return;

                itemsContainer.html("");

                if (cart.item_count === 0) {
                    if (emptyState.length) emptyState.show();
                    if (footer.length) footer.hide();
                    e("#cart-drawer-subtotal").html("");
                      return;
                  }

                    if (emptyState.length) emptyState.hide();
                    if (footer.length) footer.show();

                  fetchVariantCompareAtMap(cart.items, function(compareAtMap) {
                      var cartCompareTotal = 0;
                      var cartHasCompareAt = false;

                    for (var i = 0; i < cart.items.length; i++) {
                        var item = cart.items[i];
                        var line = i + 1;
                          var linePrice = (typeof item.final_line_price !== "undefined") ? item.final_line_price : item.line_price;
                          var unitPrice = (typeof item.final_price !== "undefined") ? item.final_price : item.price;
                          var compareAtUnit = compareAtMap[item.variant_id] || 0;
                          var compareAtLine = compareAtUnit * item.quantity;
                          var showCompareAt = compareAtUnit > unitPrice;

                          if (showCompareAt) {
                              cartCompareTotal += compareAtLine;
                              cartHasCompareAt = true;
                          } else {
                              cartCompareTotal += linePrice;
                          }

                        var html = '<li class="cart-drawer-item" id="cart-drawer-item-' + item.id + '" data-line="' + line + '">';
                        if (item.image) {
                            html += '<a href="' + item.url + '" class="cart-drawer-item__image">';
                            html +=   '<img src="' + item.image + '" alt="' + item.title + '">';
                            html += '</a>';
                        }
                        html += '<div class="cart-drawer-item__info">';
                        html +=   '<a href="' + item.url + '" class="cart-drawer-item__title">' + item.product_title + '</a>';
                        if (item.variant_title && item.variant_title.indexOf("Default") === -1) {
                            html += '<div class="cart-drawer-item__variant">' + item.variant_title + '</div>';
                        }
                        html +=   '<div class="cart-drawer-item__qty-price">';
                        html +=     '<div class="cart-drawer-qty-box" data-line="' + line + '">';
                        html +=       '<button type="button" class="cart-drawer-qty-btn cart-drawer-qty-minus" aria-label="Decrease quantity">';
                        html +=         '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">';
                        html +=           '<path d="M3.33325 8H12.6666" stroke="#3F3F46" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>';
                        html +=         '</svg>';
                        html +=       '</button>';
                        html +=       '<input type="number" min="1" class="cart-drawer-qty-input" data-line="' + line + '" value="' + item.quantity + '">';
                        html +=       '<button type="button" class="cart-drawer-qty-btn cart-drawer-qty-plus" aria-label="Increase quantity">';
                        html +=         '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">';
                        html +=           '<path d="M8 13V3M13 8L3 8" stroke="#3F3F46" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"></path>';
                        html +=         '</svg>';
                        html +=       '</button>';
                        html +=     '</div>';
                        html +=     '<div class="cart-drawer-item__remove-container">';
                        html +=       '<button type="button" class="cart-drawer-item__remove" data-line="' + line + '" aria-label="Remove item">';
                        html +=         '<svg xmlns="http://www.w3.org/2000/svg" width="10" height="12" viewBox="0 0 10 12" fill="none">';
                        html +=           '<path d="M9.45 1.75C9.55208 1.75 9.63594 1.78281 9.70156 1.84844C9.76719 1.91406 9.8 1.99792 9.8 2.1V2.45C9.8 2.55208 9.76719 2.63594 9.70156 2.70156C9.63594 2.76719 9.55208 2.8 9.45 2.8H9.1L8.64062 10.2156C8.62604 10.4927 8.51667 10.726 8.3125 10.9156C8.10833 11.1052 7.86771 11.2 7.59062 11.2H2.20937C1.93229 11.2 1.69167 11.1052 1.4875 10.9156C1.28333 10.726 1.17396 10.4927 1.15937 10.2156L0.7 2.8H0.35C0.247917 2.8 0.164062 2.76719 0.0984375 2.70156C0.0328125 2.63594 0 2.55208 0 2.45V2.1C0 1.99792 0.0328125 1.91406 0.0984375 1.84844C0.164062 1.78281 0.247917 1.75 0.35 1.75H2.14375L2.8875 0.503125C3.09167 0.167708 3.39792 0 3.80625 0H5.99375C6.40208 0 6.70833 0.167708 6.9125 0.503125L7.65625 1.75H9.45ZM3.80625 1.05L3.36875 1.75H6.43125L5.99375 1.05H3.80625ZM7.59062 10.15L8.05 2.8H1.75L2.20937 10.15H7.59062Z" fill="black"></path>';
                        html +=         '</svg>';
                        html +=       '</button>';
                        html +=     '</div>';
                        html +=   '</div>';
                        html +=   '<div class="cart-drawer-item__price-container">';
                          html +=     '<span class="cart-drawer-item__price"><span class="money">' + formatMoneySymbolOnly(linePrice) + '</span></span>';
                          if (showCompareAt) {
                              html += '<span class="cart-drawer-item__price cart-drawer-item__price--compare"><s><span class="money">' + formatMoneySymbolOnly(compareAtLine) + '</span></s></span>';
                          }
                        html +=   '</div>';
                        html += '</div></li>';
                        itemsContainer.append(html);
                    }

                      var subtotalHtml = '<span class="money cart-drawer__subtotal-price">' + formatMoneySymbolOnly(cart.total_price) + '</span>';
                      if (cartHasCompareAt && cartCompareTotal > cart.total_price) {
                          subtotalHtml += '<span class="money cart-drawer__subtotal-price cart-drawer__subtotal-price--compare"><s>' + formatMoneySymbolOnly(cartCompareTotal) + '</s></span>';
                      }
                      e("#cart-drawer-subtotal").html(subtotalHtml);

                    // Keep header cart counts (desktop + mobile) in sync when drawer refreshes
                    updateHeaderCartCounts(cart.item_count);

                    var hasWarranty = false;
                    var warrantyId = getWarrantyVariantId();
                    if (warrantyId) {
                        for (var j = 0; j < cart.items.length; j++) {
                            if (cart.items[j].variant_id == warrantyId) {
                                hasWarranty = true;
                                break;
                            }
                        }
                    }
                    var warrantyEl = e("#cart-drawer-warranty-offer");
                    if (warrantyEl.length) {
                        if (hasWarranty || cart.item_count === 0) {
                            warrantyEl.hide();
                        } else {
                            warrantyEl.show();
                        }
                    }

                    if (n.checkNeedToConvertCurrency && n.checkNeedToConvertCurrency()) {
                        Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "#cart-drawer span.money", "money_format");
                    }
                  });
            });
        },
        updateCartLineQuantity: function(line, quantity) {
            var n = this;
            line = parseInt(line, 10);
            quantity = parseInt(quantity, 10);
            if (!line || quantity < 1) return;
            console.log("updateCartLineQuantity", { line: line, quantity: quantity });
            e.ajax({
                type: "post",
                url: "/cart/change.js",
                data: {
                    line: line,
                    quantity: quantity
                },
                dataType: "json",
                success: function(cart) {
                    console.log("✅ Cart line updated", cart);
                    n.refreshCartDrawer();
                    if (typeof n.doUpdateDropdownCart === "function") {
                        n.doUpdateDropdownCart(cart);
                    }
                },
                error: function(xhr, status) {
                    console.error("❌ Failed to update cart line", xhr, status);
                }
            });
        },
        initProductAddToCart: function() {
            // Legacy product template Add to Cart (#AddToCart)
            if (e("#AddToCart").length > 0) {
                console.log("initProductAddToCart: binding click handler for #AddToCart");
                e("#AddToCart").off("click.ocwAtc").on("click.ocwAtc", function(n) {
                    n.preventDefault();
                    console.log("AddToCart clicked (forced AJAX)", {
                        ajax_cart: window.ajax_cart,
                        use_cart_drawer: window.use_cart_drawer
                    });
                    if (e(this).attr("disabled") != "disabled") {
                        var r = e("#AddToCartForm select[name=id]").val();
                        if (!r) {
                            r = e("#AddToCartForm input[name=id]").val()
                        }
                        var i = e("#AddToCartForm select[name=quantity]").val();
                        if (!i) {
                            i = 1
                        }
                        var o = e("#product-featured-image").attr("src");
                        var p = e(".product-single__title").text();
                        var amt = e(".product_single_price .grid-link__org_price span.money").text();
                        console.log("initProductAddToCart payload", {
                            variantId: r,
                            quantity: i,
                            image: o,
                            title: p,
                            amountText: amt
                        });
                        t.doAjaxAddToCart(r, i, o, p, amt)
                    }
                    return false
                })
            }

            // OCW product template Add to Cart (main)
            if (e(".js-ocw-atc-btn-main").length > 0) {
                console.log("initProductAddToCart: binding OCW main ATC");
                e(".js-ocw-atc-btn-main").off("click.ocwAtc").on("click.ocwAtc", function(n) {
                    n.preventDefault();
                    var form = e(this).closest("form.js-ocw-atc-form-main");
                    if (!form.length || e(this).attr("disabled") == "disabled") return false;
                    var variantId = form.find("input[name=id]").val();
                    var qtyInput = form.find("input[name=quantity], select[name=quantity]");
                    var qty = qtyInput.length ? qtyInput.val() : 1;
                    if (!qty) qty = 1;
                    console.log("OCW main ATC payload", {
                        variantId: variantId,
                        quantity: qty
                    });
                    t.doAjaxAddToCart(variantId, qty, null, e(".product-ocw-title").text() || "");
                    return false;
                });
            }

            // OCW sticky header Add to Cart (top)
            if (e(".js-ocw-atc-btn-top").length > 0) {
                console.log("initProductAddToCart: binding OCW sticky ATC");
                e(".js-ocw-atc-btn-top").off("click.ocwAtc").on("click.ocwAtc", function(n) {
                    n.preventDefault();
                    var form = e(this).closest("form.js-ocw-atc-form-top");
                    if (!form.length || e(this).attr("disabled") == "disabled") return false;
                    var variantId = form.find("input[name=id]").val();
                    var qty = 1;
                    console.log("OCW sticky ATC payload", {
                        variantId: variantId,
                        quantity: qty
                    });
                    t.doAjaxAddToCart(variantId, qty, null, e(".product-ocw-title").text() || "");
                    return false;
                });
            }
        },
        initAddToCart: function() {
            if (e(".add-cart-btn").length > 0) {
                console.log("initAddToCart: binding click handler for .add-cart-btn");
                e(".add-cart-btn").click(function(n) {
                    n.preventDefault();
                    console.log("Collection add-cart-btn clicked (forced AJAX)", {
                        ajax_cart: window.ajax_cart,
                        use_cart_drawer: window.use_cart_drawer
                    });
                    if (e(this).attr("disabled") != "disabled") {
                        var r = e(this).parents(".item-row");
                        var i = e(r).attr("id");
                        i = i.match(/\d+/g);
                        var s = e("#cart-form-" + i + " select[name=id]").val();
                        if (!s) {
                            s = e("#cart-form-" + i + " input[name=id]").val()
                        }
                        var o = e("#cart-form-" + i + " select[name=quantity]").val();
                        if (!o) {
                            o = 1
                        }
                        var a = e(r).find(".featured-image").attr("src");
                        var p = e(r).find(".grid-link__title").text();
                        var amt = e(r).find(".grid-link__meta .product_price .grid-link__org_price span.money").text();
                        console.log("initAddToCart payload", {
                            formIndex: i,
                            variantId: s,
                            quantity: o,
                            image: a,
                            title: p,
                            amountText: amt
                        });
                        t.doAjaxAddToCart(s, o, a, p, amt)
                    }
                    return false
                })
            }
        },
        showLoading: function() {
            e(".loading-modal").show()
        },
        hideLoading: function() {
            e(".loading-modal").hide()
        },
        doAjaxAddToCart: function(n, r, a, p, amt) {
            console.log("doAjaxAddToCart called", {
                variantId: n,
                quantity: r,
                image: a,
                title: p,
                amountText: amt,
                ajax_cart: window.ajax_cart,
                use_cart_drawer: window.use_cart_drawer
            });
            e.ajax({
                type: "post",
                url: "/cart/add.js",
                data: "quantity=" + r + "&id=" + n,
                dataType: "json",
                beforeSend: function() {
                    if (!window.use_cart_drawer) {
                        t.showLoading()
                    }
                },
                success: function(n) {
                    console.log("✅ AJAX add to cart success", n);
                    if (!window.use_cart_drawer) {
                        t.hideLoading();
                    }
                    if (window.use_cart_drawer) {
                        console.log("Using cart drawer UI after add-to-cart");
                        t.updateDropdownCart();
                        t.refreshCartDrawer();
                        t.openCartDrawer();
                    } else {
                        console.log("Using legacy AJAX success modal after add-to-cart");
                        t.showModal(".ajax-success-modal");
                        e(".ajax-success-modal").find(".ajax-product-image").attr("src", a);
                        e(".ajax-success-modal").find(".added-to-wishlist").hide();
                        e(".ajax-success-modal").find(".added-to-cart").show();
                        e(".ajax-success-modal").find(".ajax-product-title").text(p);
                        e(".ajax-success-modal").find(".ajax_price").text(amt);
                        t.updateDropdownCart();
                    }
                },
                error: function(n, r) {
                    t.hideLoading();
                    var message = "";
                    try {
                        message = e.parseJSON(n.responseText).description;
                    } catch (err) {
                        message = n.responseText || "Unknown error";
                    }
                    console.error("❌ AJAX add to cart error", {
                        xhr: n,
                        status: r,
                        message: message
                    });
                    e(".ajax-error-message").text(message);
                    t.showModal(".ajax-error-modal")
                }
            })
        },
        initQuickView: function() {
            e(".quick-view-text").click(function() {
              e('.quick-view').addClass('open-in');               
                var n = e(this).attr("id");
                Shopify.getProduct(n, function(n) {
                    var r = e("#quickview-template").html();
                    e(".quick-view").html(r);
                    var i = e(".quick-view");
                    var s = n.description.replace(/(<([^>]+)>)/ig, "");
                    s = s.split(" ").splice(0, 40).join(" ") + "...";
                    i.find(".product-title a").text(n.title);
                    i.find(".product-title a").attr("href", n.url);
                    if (i.find(".product-inventory span").length > 0) {
                        var o = n.variants[0].inventory_quantity;
                        if (o > 0) {
                            if (n.variants[0].inventory_management != null) {
                                i.find(".product-inventory span").text(o + " in stock")
                            } else {
                                i.find(".product-inventory span").text("Many in stock")
                            }
                        } else {
                            i.find(".product-inventory span").text("Out of stock")
                        }
                    }
                    i.find(".product-description").text(s);
                    i.find(".price").html(Shopify.formatMoney(n.price, window.money_format));
                    i.find(".product-item").attr("id", "product-" + n.id);
                    i.find(".variants").attr("id", "product-actions-" + n.id);
                    i.find(".variants select").attr("id", "product-select-" + n.id);
                    if (n.compare_at_price > n.price) {
                        i.find(".compare-price").html(Shopify.formatMoney(n.compare_at_price_max, window.money_format)).show();
                        i.find(".price").addClass("on-sale")
                    } else {
                        i.find(".compare-price").html("");
                        i.find(".price").removeClass("on-sale")
                    }
                    if (!n.available) {
                        i.find("select, input, .total-price, .dec, .inc, .variants label").remove();
                        i.find(".add-to-cart-btn").text("Unavailable").addClass("disabled").attr("disabled", "disabled");
                        i.find(".product-inventory").css("opacity","0");
                    } else {                        
                        i.find(".total-price .price").html(Shopify.formatMoney(n.price, window.money_format));
                        i.find(".product-inventory").css("opacity","1");
                         t.createQuickViewVariants(n, i)
                        
                    }
                    i.find(".button").on("click", function() {
                        var n = i.find(".quantity").val(),
                            r = 1;
                        if (e(this).text() == "+") {
                            r = parseInt(n) + 1
                        } else if (n > 1) {
                            r = parseInt(n) - 1
                        }
                        i.find(".quantity").val(r);
                    });
                  
                    t.loadQuickViewSlider(n, i);
                    t.initQuickviewAddToCart();
                    e(".quick-view").fadeIn(500);
                   
                });
                return false
            });
             e(".quick-view .overlay, .close-window").live("click", function() {
                t.closeQuickViewPopup();
               e('.quick-view').removeClass("open-in");
               e('.quick-view').removeClass("option-loader");
               
                return false
            })
           
        },
        
        initQuickviewAddToCart: function() {
            if (e(".quick-view .add-to-cart-btn").length > 0) {
                e(".quick-view .add-to-cart-btn").click(function() {
                    var n = e(".quick-view select[name=id]").val();
                    if (!n) {
                        n = e(".quick-view input[name=id]").val()
                    }
                    var r = e(".quick-view input[name=quantity]").val();
                    if (!r) {
                        r = 1
                    }
                    var p = e('.quick-view .product-title a').html();
                    var a = e(".quick-view .quickview-featured-image img").attr("src");                 
                    t.doAjaxAddToCart(n, r, a, p);
                    t.closeQuickViewPopup();
                    e('.quick-view').removeClass("open-in");
               		e('.quick-view').removeClass("option-loader");
                })
            }
        },
        updateDropdownCart: function() {
            Shopify.getCart(function(e) {
                t.doUpdateDropdownCart(e)
            })
        },
        doUpdateDropdownCart: function(n) {
            var r = '<li class="item" id="cart-item-{ID}"><a href="{URL}" title="{TITLE}" class="product-image"><img src="{IMAGE}" alt="{TITLE}"></a><div class="product-details"><a href="javascript:void(0)" title="Remove This Item" class="btn-remove"><span class="icon-close"></span></a><p class="product-name"><a href="{URL}">{TITLE}</a></p><div class="cart-collateral">{QUANTITY} x <span class="price">{PRICE}</span></div></div></li>';
            // Update header cart counts (desktop + mobile) when dropdown cart changes
            updateHeaderCartCounts(n.item_count);

            e("#minicart_total span.money").html(formatMoneySymbolOnly(n.total_price));
            e("#slidedown-cart .summary .price").html(formatMoneySymbolOnly(n.total_price));
            e("#slidedown-cart .mini-products-list").html("");
            if (n.item_count > 0) {
                for (var i = 0; i < n.items.length; i++) {
                    var s = r;
                    s = s.replace(/\{ID\}/g, n.items[i].id);
                    s = s.replace(/\{URL\}/g, n.items[i].url);
                    s = s.replace(/\{TITLE\}/g, n.items[i].title);
                    s = s.replace(/\{QUANTITY\}/g, n.items[i].quantity);
                    s = s.replace(/\{IMAGE\}/g, Shopify.resizeImage(n.items[i].image, "small"));
                    s = s.replace(/\{PRICE\}/g, formatMoneySymbolOnly(n.items[i].price));
                    e("#slidedown-cart .mini-products-list").append(s)
                }
                e("#slidedown-cart .btn-remove").click(function(n) {
                    n.preventDefault();
                    var r = e(this).parents(".item").attr("id");
                    r = r.match(/\d+/g);
                    Shopify.removeItem(r, function(e) {
                        t.doUpdateDropdownCart(e);                      
                    })
                });
                if (t.checkNeedToConvertCurrency()) {
                    Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '#slidedown-cart span.money', 'money_format')
                    Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '#minicart_total span.money', 'money_format')
                    
                }
            }
            t.checkItemsInDropdownCart()
        },
        checkNeedToConvertCurrency: function() {
            return window.show_multiple_currencies && Currency.currentCurrency != shopCurrency
        },
        loadQuickViewSlider: function(n, r) {
            var s = Shopify.resizeImage(n.featured_image, "large");
            r.find(".quickview-featured-image").append('<a href="' + n.url + '"><img src="' + s + '" title="' + n.title + '"/><div style="height: 100%; width: 100%; top:0px; left:-260px; z-index: 2000; position: absolute; display: none; background: url(' + window.loading_url + ') 50% 50% no-repeat;"></div></a>');
            if (n.images.length > 1) {
                var o = r.find(".more-view-wrapper ul");
                for (i in n.images) {
                    var u = Shopify.resizeImage(n.images[i], "large");
                    var a = Shopify.resizeImage(n.images[i], "small");
                    var f = '<li><a href="javascript:void(0)" data-image="' + u + '"><img src="' + a + '"  /></a></li>';
                    o.append(f)
                }
                o.find("a").click(function() {
                    var t = r.find(".quickview-featured-image img");
                    var n = r.find(".quickview-featured-image div");
                    if (t.attr("src") != e(this).attr("data-image")) {
                        t.attr("src", e(this).attr("data-image"));
                        n.show();
                        t.load(function(t) {
                            n.hide();
                            e(this).unbind("load");
                            n.hide()
                        })
                    }
                });
               
                 if (o.hasClass("quickview-more-views-owlslider")) {
                    t.initQuickViewMoreview(o)
                } else {
                    t.initQuickViewMoreview(o)
                }
              
            } else {
             
                r.find(".more-view-wrapper").remove();
               
            } 
        },
         closeEmailModalWindow: function() {
            if (e("#email-modal").length > 0 && e("#email-modal").is(":visible")) {
                e("#email-modal .modal-window").fadeOut(600, function() {
                    e("#email-modal .modal-overlay").fadeOut(600, function() {
                        e("#email-modal").hide();
                        e.cookie("emailSubcribeModal", "closed", {
                            expires: 1,
                            path: "/"
                        })
                    })
                })
            }
        },
        initQuickViewMoreview: function(t) {
            if (t) {
                t.owlCarousel({
                    navigation: false,
                    items: 4,
                    itemsDesktop: [1199, 4],
                    itemsDesktopSmall: [979, 3],
                    itemsTablet: [768, 3],
                    itemsTabletSmall: [540, 3],
                    itemsMobile: [360, 3],
                    pagination: true
                }).css("visibility", "visible")
            }
          
        },
      
     
        convertToSlug: function(e) {
            return e.toLowerCase().replace(/[^a-z0-9 -]/g, "").replace(/\s+/g, "-").replace(/-+/g, "-")
        },
       
        createQuickViewVariants: function(t, n) {
            if (t.variants.length > 1) {
                for (var r = 0; r < t.variants.length; r++) {
                    var i = t.variants[r];
                    var s = '<option value="' + i.id + '">' + i.title + "</option>";
                    n.find("form.variants > select").append(s)
                }
                new Shopify.OptionSelectors("product-select-" + t.id, { product: t,  onVariantSelected: selectCallbackQuickview  });
               
                if (t.options.length == 1) {
                    e(".selector-wrapper:eq(0)").prepend("<label>" + t.options[0].name + "</label>")
                }
              
              n.find("form.variants .selector-wrapper select").each(function(n, r) {
                e(this).wrap('<div class="selector-arrow">');
              })
                n.find("form.variants .selector-wrapper label").each(function(n, r) {
                    e(this).html(t.options[n].name)
                })
            } else {
                n.find("form.variants > select").remove();
                var o = '<input type="hidden" name="id" value="' + t.variants[0].id + '">';
                n.find("form.variants").append(o)
            }
        },      
            closeQuickViewPopup: function() {
            e(".quick-view").fadeOut(500)
        },
       initSidebar: function() {
            //if category page then init sidebar
            if (e(".collection_sidebar").length > 0) {
                t.sidebarParams();              
                t.sidebarMapEvents();               
                t.sidebarInitToggle();
                t.sidebarMapClear();
                t.sidebarMapClearAll();
                t.initSortby();                
                t.sidebarMapPaging();
            }
        },
      
       sidebarMapView: function() {
            e(".view-mode a").click(function(n) {
                if (!e(this).hasClass("active")) {
                    var paging = e(".filter-show  button span").text();
                    if (e(this).hasClass("list")) {
                        Shopify.queryParams.view = "list" + paging;
                    } else {
                        Shopify.queryParams.view = paging;
                    }

                    t.sidebarAjaxClick();
                    e(".view-mode a.active").removeClass("active");
                    e(this).addClass("active");
                }
                n.preventDefault();
            });
        },
       
      
      
      
        sidebarMapSorting: function(n) {
            e(".filter-sortby a").click(function(n) {
                if (!e(this).parent().hasClass("active")) {
                    Shopify.queryParams.sort_by = e(this).attr("href");
                    t.sidebarAjaxClick();
                    var sortbyText = e(this).text();                  
                    e(".filter-sortby  button span").text(sortbyText);
                    e(".filter-sortby li.active").removeClass("active");
                    e(this).parent().addClass("active");
                }
                n.preventDefault();
            });
        },
      
       initSortby: function() {
            //sort by filter
            if (Shopify.queryParams.sort_by) {
                var sortby = Shopify.queryParams.sort_by;
                var sortbyText = e(".filter-sortby a[href='" + sortby + "']").text();
                e(".filter-sortby  button span").text(sortbyText);
                e(".filter-sortby li.active").removeClass("active");
                e(".filter-sortby a[href='" + sortby + "']").parent().addClass("active");
            }
        },
        sidebarMapPaging: function() {
            e(".pagination-custom a").click(function(n) {
                var page = e(this).attr("href").match(/page=\d+/g);
                if (page) {
                    Shopify.queryParams.page = parseInt(page[0].match(/\d+/g));
                    if (Shopify.queryParams.page) {
                        var newurl = t.sidebarCreateUrl();
                        t.isSidebarAjaxClick = true;
                        History.pushState({
                            param: Shopify.queryParams
                        }, newurl, newurl);
                        t.sidebarGetContent(newurl);
                        //go to top
                        e('body,html').animate({
                            scrollTop: 500
                        }, 600);
                    }
                }
                n.preventDefault();
            });
        },
       sidebarMapTagEvents: function() {
          	e('.sidebar-tag a:not(".clear"), .sidebar-tag label').click(function(n) {
                var currentTags = [];
                if (Shopify.queryParams.constraint) {
                    currentTags = Shopify.queryParams.constraint.split('+');
                }

                //one selection or multi selection
                if (!window.enable_sidebar_multiple_choice && !e(this).prev().is(":checked")) {
                    //remove other selection first
                    var otherTag = e(this).parents('.sidebar-tag').find("input:checked");
                    if (otherTag.length > 0) {
                        var tagName = otherTag.val();
                        if (tagName) {
                            var tagPos = currentTags.indexOf(tagName);
                            if (tagPos >= 0) {
                                //remove tag
                                currentTags.splice(tagPos, 1);
                            }
                        }
                    }
                }

                var tagName = e(this).prev().val();
                if (tagName) {
                    var tagPos = currentTags.indexOf(tagName);
                    if (tagPos >= 0) {
                        //tag already existed, remove tag
                        currentTags.splice(tagPos, 1);
                    } else {
                        //tag not existed
                        currentTags.push(tagName);
                    }
                }
                if (currentTags.length) {
                    Shopify.queryParams.constraint = currentTags.join('+');
                } else {
                    delete Shopify.queryParams.constraint;
                }
                t.sidebarAjaxClick();
                n.preventDefault();
            });
        },
       
        
      
        sidebarInitToggle: function() {
            if (e(".sidebar-tag").length > 0) {
                e(".sidebar-tag .widget span").click(function() {
                    var $title = e(this).parents('.widget');
                    if ($title.hasClass('click')) {
                        $title.removeClass('click');
                    } else {
                        $title.addClass('click');
                    }

                    e(this).parents(".sidebar-tag").find(".widget-content").slideToggle();
                });
            }
        },
       
       
        sidebarMapClearAll: function() {
            //clear all selection
            e('.refined-widgets a.clear-all').click(function(n) {
                delete Shopify.queryParams.constraint;
                delete Shopify.queryParams.q;
                t.sidebarAjaxClick();
                n.preventDefault();
            });
        },
        sidebarMapClear: function() {
            e(".sidebar-tag").each(function() {
                var sidebarTag = e(this);
                if (sidebarTag.find("input:checked").length > 0) {
                    //has active tag
                    sidebarTag.find(".clear").show().click(function(n) {                     
                        var currentTags = [];
                        if (Shopify.queryParams.constraint) {
                            currentTags = Shopify.queryParams.constraint.split('+');
                        }
                        sidebarTag.find("input:checked").each(function() {
                            var selectedTag = e(this);
                            var tagName = selectedTag.val();
                            if (tagName) {
                                var tagPos = currentTags.indexOf(tagName);
                                if (tagPos >= 0) {
                                    //remove tag
                                    currentTags.splice(tagPos, 1);
                                }
                            }
                        });
                        if (currentTags.length) {
                            Shopify.queryParams.constraint = currentTags.join('+');
                        } else {
                            delete Shopify.queryParams.constraint;
                        }
						t.sidebarAjaxClick();
                        n.preventDefault();
                    });
                }
            });
        },
        sidebarMapEvents: function() {
            t.sidebarMapTagEvents();
            t.sidebarMapView();            
            t.sidebarMapSorting();
        },
         reActivateSidebar: function() {
            e(".sidebar-tag .active").removeClass("active");
            e(".sidebar-tag input:checked").attr("checked", false);

           

            //view mode and show filter
            if (Shopify.queryParams.view) {
                e(".view-mode .active").removeClass("active");
                var view = Shopify.queryParams.view;
                if (view.indexOf("list") >= 0) {
                    e(".view-mode .list").addClass("active");
                    //paging
                    view = view.replace("list", "");
                } else {
                    e(".view-mode .grid").addClass("active");
                }
                e(".filter-show  button span").text(view);
                e(".filter-show li.active").removeClass("active");
                e(".filter-show a[href='" + view + "']").parent().addClass("active");
            }
            t.initSortby();
        },
        sidebarMapData: function(data) {
            var currentList = e(".col-main .products-grid-view");
            if (currentList.length == 0) {
                currentList = e(".col-main .product-list-view");
            }
            var productList = e(data).find(".col-main .products-grid-view");
            if (productList.length == 0) {
                productList = e(data).find(".col-main .product-list-view");
            }           
            currentList.replaceWith(productList);
            //convert currency
            if (t.checkNeedToConvertCurrency()) {
                Currency.convertAll(window.shop_currency, jQuery('#currencies').val(), '.col-main span.money', 'money_format');
            }

            //replace refined
            e(".refined-widgets").replaceWith(e(data).find(".refined-widgets"));
            
            //replace tags
            e(".sidebar-block").replaceWith(e(data).find(".sidebar-block"));
                   
          //replace paging
            if (e(".padding").length > 0) {
                e(".padding").replaceWith(e(data).find(".padding"));
            } else {
                e(".grid-link__container.col-main").append(e(data).find(".padding"));
            }
          
           if ($(".spr-badge").length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
            }
        },
        sidebarCreateUrl: function(baseLink) {
            var newQuery = e.param(Shopify.queryParams).replace(/%2B/g, '+');
            if (baseLink) {
                //location.href = baseLink + "?" + newQuery;
                if (newQuery != "")
                    return baseLink + "?" + newQuery;
                else
                    return baseLink;
            }
            return location.pathname + "?" + newQuery;
        },
        sidebarAjaxClick: function(baseLink) {
            delete Shopify.queryParams.page;
            var newurl = t.sidebarCreateUrl(baseLink);
            t.isSidebarAjaxClick = true;
            History.pushState({
                param: Shopify.queryParams
            }, newurl, newurl);
            t.sidebarGetContent(newurl);
        },
        sidebarGetContent: function(newurl) {
            $.ajax({
                type: 'get',
                url: newurl,
                beforeSend: function() {
                    t.showLoading();
                },
                success: function(data) {
                    t.sidebarMapData(data);
                    t.sidebarMapTagEvents();
                    t.sidebarInitToggle();
                    t.sidebarMapClear();
                    t.sidebarMapClearAll();
                    t.hideLoading();
                    t.initQuickView();
                    t.initAddToCart();
                    t.initWishlist();
                    t.sidebarMapPaging()
                },
                error: function(xhr, text) {
                    t.hideLoading();
                    e('.loading-modal').hide();
                    e('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                    t.showModal('.ajax-error-modal');
                }
            });
        },
        sidebarParams: function() {
            Shopify.queryParams = {};
            //get after ?...=> Object {q: "Acme"} 
            if (location.search.length) {
                for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
                    aKeyValue = aCouples[i].split('=');
                    if (aKeyValue.length > 1) {
                        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
                    }
                }
            }
        },
       initInfiniteScrolling: function() {
            e(".infinite-scrolling").length > 0 && e(".infinite-scrolling a").click(function(i) {
                i.preventDefault(), e(this).hasClass("disabled") || t.doInfiniteScrolling()
            })
        },
        doInfiniteScrolling: function() {
            var currentList = $('.col-main .products-grid-view');
            if (!currentList.length) {
                currentList = $('.col-main .product-list-view');
            }
            if (currentList) {
                var showMoreButton = $('.infinite-scrolling a').first();
                $.ajax({
                    type: 'GET',
                    url: showMoreButton.attr("href"),
                    beforeSend: function() {
                        t.showLoading();
                        $('.loading-modal').show();
                    },
                    success: function(data) {
                        t.hideLoading();
                        var products = $(data).find(".col-main .products-grid-view");
                        if (!products.length) {
                            products = $(data).find(".col-main .product-list-view");
                        }
                        if (products.length) {
                            currentList.append(products.children());
                            t.initQuickView();
                            t.initAddToCart();
                            t.initWishlist();
                            //get link of Show more
                            if ($(data).find('.infinite-scrolling').length > 0) {
                                showMoreButton.attr('href', $(data).find('.infinite-scrolling a').attr('href'));
                            } else {
                                //no more products
                                showMoreButton.hide();
                                showMoreButton.next().show();
                            }
                          
                          	//currency
                            if (window.show_multiple_currencies && window.shop_currency != jQuery("#currencies").val())
                            {
                                Currency.convertAll(window.shop_currency, jQuery("#currencies").val(), "span.money", "money_format")
                            }
                          
                            t.initColorSwatchGrid();
                          
                            //product review
                            if ($(".spr-badge").length > 0) {
                                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                            }
                        }
                    },
                    error: function(xhr, text) {
                        t.hideLoading();
                        $('.loading-modal').hide();
                        $('.ajax-error-message').text($.parseJSON(xhr.responseText).description);
                        t.showModal('.ajax-error-modal');
                    },
                    dataType: "html"
                });
            }
        }
      
    }
    
    
    
    
})(jQuery)